import * as React from 'react';
import Box from '@mui/material/Box';
import ViewMeetingRequests from './ViewMeetingRequests';

const MeetingRequestHome = () => {

    return (
        <Box sx={{ width: '100%' }}>
            <ViewMeetingRequests />
        </Box>
    );
}

export default MeetingRequestHome